var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJfcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#296fcd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.817682, 18.580674)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.226562 0 C 8.171875 0 8.925781 -0.777344 8.925781 -1.699219 L 8.925781 -8.503906 L 3.824219 -8.503906 L 3.824219 -6.800781 L 7.226562 -6.800781 L 7.226562 -1.699219 L 2.125 -1.699219 L 2.125 -3.402344 L 0.425781 -3.402344 L 0.425781 -1.699219 C 0.425781 -0.765625 1.191406 0 2.125 0 Z M 7.226562 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#296fcd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.169964, 18.580674)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.925781 -8.503906 L 2.125 -8.503906 C 1.191406 -8.503906 0.425781 -7.738281 0.425781 -6.800781 L 0.425781 0 L 2.125 0 L 2.125 -3.402344 L 8.925781 -3.402344 L 8.925781 -5.101562 L 2.125 -5.101562 L 2.125 -6.800781 L 8.925781 -6.800781 Z M 8.925781 -8.503906 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#296fcd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.522245, 18.580674)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.925781 0 L 8.925781 -1.699219 L 2.125 -1.699219 L 2.125 -6.800781 L 8.925781 -6.800781 L 8.925781 -8.503906 L 2.125 -8.503906 C 1.191406 -8.503906 0.425781 -7.738281 0.425781 -6.800781 L 0.425781 -1.699219 C 0.425781 -0.765625 1.191406 0 2.125 0 Z M 8.925781 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJfcLogo);
export default __webpack_public_path__ + "static/media/jfc-logo.748b764559794a65e2928e6ad7d0c5fa.svg";
export { ForwardRef as ReactComponent };